/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: supervision-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// For autocomplete fields
var $j = jQuery.noConflict(); 
$j(function(){
    var ajaxes = {
        "parametres":             "/supervision/autocompletionParametrage?EXT=supervision",
        "internationalisation": "/supervision/autocompletionI18N?EXT=supervision"
    };

    $j("[data-use=autocomplete]").pAutocomplete(ajaxes);
});

// autosubmit when changing the number of results per page, in screen "FICHIERS JOURNAUX"
$j("#nResultsPerPages").change(function() {
    $j("#filter").submit();
});

/**
 * Sort an HTML select element
 * @param selElem the DOM element
 */
function sortSelect(selElem) {
    var tmpAry = new Array();
    for (var i=0;i<selElem.options.length;i++) {
        tmpAry[i] = new Array();
        tmpAry[i][0] = selElem.options[i].text;
        tmpAry[i][1] = selElem.options[i].value;
        tmpAry[i][2] = (selElem.options[i].attributes["data-selected"] == null ? 0 : 1);
    }
    tmpAry.sort();
    while (selElem.options.length > 0) {
        selElem.options[0] = null;
    }
    for (var i=0;i<tmpAry.length;i++) {
        var op = new Option(tmpAry[i][0], tmpAry[i][1]);
        if (tmpAry[i][2] == 1) op.setAttribute("selected", "selected");
        selElem.options[i] = op;
    }
    return;
}

(function($) {

    $("*[data-sort]").each(function() {
        sortSelect(this);
    });

    // Folding divs
    $("fieldset.fold").each(function() {
        var $f = $(this);
        var legend = $f.find('legend');
        var elements = $f.find('.fold-inside');

        elements.hide();

        legend.css('cursor', 'pointer');
        legend.append(" <span class='triangle down'>&#9662;</span>");

        legend.click(function() {
            $t = legend.find('.triangle');

            if ($t.hasClass('down')) {
                $t.html('&#9652;');
                $t.removeClass('down').addClass('up');
            } else {
                $t.html('&#9662;');
                $t.removeClass('up').addClass('down');
            }

            elements.toggle(100);
        });
    });

    /**
     * Multi-valued component (list to list mode)
     */
    var $kProcessBuilder = $('.kprocessbuilder');
    if ($kProcessBuilder.length > 0) {
        $kProcessBuilder.each(function(index, component){
            $(component).kProcessBuilder({
                instance : false,
                sortable: true,
                editable:  $(component).hasClass('editable') ? true : false,
                removable: true,
                multiSelect: false,
                oldMode: true,
                editAction: function(row){
                    if(window.specificEditAction) window.specificEditAction(row);
                },
                onAfterItemAdd: function(list, items){
                    if(list.hasClass('kprocessbuilder-composition-list')){
                        var $kProcessBuilder = list.closest('.kprocessbuilder'),
                            $input = $kProcessBuilder.find('input[name="' + $kProcessBuilder.attr('id').replace('kprocessbuilder', '') + '"]'),
                            values = $.cleanArray($input.val().split(';')).join(';');
                        $input.val(values);
                        items.each(function(){
                            if($input.val()){
                                $input.val($input.val() + ";" + $(this).data('value'));
                            }else{
                                $input.val($(this).data('value'));
                            }
                        });
                    }
                    window.specificAfterItemAdd(list, items);
                },
                onAfterItemRemove: function(list, items){
                    if(list.hasClass('kprocessbuilder-composition-list')){
                        var $kProcessBuilder = list.closest('.kprocessbuilder'),
                            $input = $kProcessBuilder.find('input[name="' + $kProcessBuilder.attr('id').replace('kprocessbuilder', '') + '"]'),
                            values = $.cleanArray($input.val().split(';'));

                        items.each(function(){
                            values.removeByValue($(this).attr('data-value'));
                        });
                        $input.val(values.join(';'));
                    }
                    if(window.specificAfterItemRemove) window.specificAfterItemRemove(list, items);
                },
                onItemSort: function($list) {
                    var $processBuilder = $list.closest('.kprocessbuilder'),
                        inputName = $processBuilder.attr('id').replace('kprocessbuilder', ''),
                        $libelles = $processBuilder.find('input[name="LIBELLE_' + inputName + '"]'),
                        $values = $processBuilder.find('input[name="' + inputName + '"]');
                    $libelles.val('');
                    $values.val('');
                    $list.find('.kprocessbuilder-composition-list-row').each(function(index) {
                        var $li = $(this),
                            separator = (index != 0 ? ';' : '');
                        $values.val($values.val() + separator + this.dataset.value);
                        $libelles.val($libelles.val() + separator + $li.find('.composition-list-label').html());
                    });
                }
            });
        });

        $kProcessBuilder.each(function(){
            var $this = $(this),
                $compositionList = $this.find('.kprocessbuilder-composition-list'),
                inputName = $this.attr('id').replace('kprocessbuilder', ''),
                libelles = $.cleanArray($this.find('input[name="LIBELLE_' + inputName + '"]').val().split(';')),
                values = $.cleanArray($this.find('input[name="' + inputName + '"]').val().split(';'));

            $.each(values, function(index, value){
                var params = value.split(',').length > 1 ? 'true' : 'false';
                $('<li data-params="' + params + '">' + libelles[index] + '</li>').attr('data-value', value).appendTo($compositionList);
            });
            $this.kProcessBuilder().update();
        });
    }

})(jQuery.noConflict());